// extracted by mini-css-extract-plugin
export default {"loader-box":"Spinner_loader-box__RU9Nt","loader":"Spinner_loader__h8PPO","spin89345":"Spinner_spin89345__Yu+09"};